import { render, staticRenderFns } from "./PatientQueue.vue?vue&type=template&id=de2fc90c&scoped=true"
import script from "./PatientQueue.vue?vue&type=script&lang=js"
export * from "./PatientQueue.vue?vue&type=script&lang=js"
import style0 from "./PatientQueue.vue?vue&type=style&index=0&id=de2fc90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2fc90c",
  null
  
)

export default component.exports